import "./Deck.css";
import {
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  TableContainer,
  useBreakpointValue,
  Button,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
} from "@chakra-ui/react";

import { useGameContext } from "../../../context/gameContext/gameContext";

// Cutthroat: one column per active seat (3 or 4), named for whoever's
// actually playing, instead of the fixed Us/Them pair.
const ScoreTable = ({
  teamAScore,
  teamBScore,
  size,
  isCutthroat,
  names,
  scores,
}) => (
  <Table variant="simple" bg={"white"} size={size}>
    <Thead>
      <Tr>
        {isCutthroat ? (
          names.map((name, i) => <Th key={i}>{name}</Th>)
        ) : (
          <>
            <Th>Us</Th>
            <Th>Them</Th>
          </>
        )}
      </Tr>
    </Thead>
    <Tbody justifyContent="center">
      <Tr>
        {isCutthroat ? (
          scores.map((score, i) => (
            <Td key={i} textAlign="center">
              {score}
            </Td>
          ))
        ) : (
          <>
            <Td textAlign="center">{teamAScore}</Td>
            <Td textAlign="center">{teamBScore}</Td>
          </>
        )}
      </Tr>
    </Tbody>
  </Table>
);

const ScoreBoard = () => {
  const {
    teamAScore,
    teamBScore,
    gameMode,
    numPlayers,
    username,
    botNames,
    individualScores,
  } = useGameContext();
  const size = useBreakpointValue({ base: "sm", md: "md" }) ?? "md";
  const isMobile = useBreakpointValue({ base: true, sm: false }) ?? false;

  const isCutthroat = gameMode === "Cutthroat";
  const activeSeats = Array.from(
    { length: Number(numPlayers) },
    (_, i) => `P${i + 1}`
  );
  const names = activeSeats.map((seat) =>
    seat === "P1" ? username : botNames[seat]
  );
  const scores = activeSeats.map((seat) => individualScores[seat]);

  if (isMobile) {
    return (
      <Popover placement="bottom-end" isLazy>
        <PopoverTrigger>
          <Button
            position="absolute"
            top="6px"
            right="6px"
            size="xs"
            zIndex={3}
            border="1px solid black"
            bg="white"
          >
            Score
          </Button>
        </PopoverTrigger>
        <PopoverContent width="auto">
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverBody p={2}>
            <ScoreTable
              teamAScore={teamAScore}
              teamBScore={teamBScore}
              size="sm"
              isCutthroat={isCutthroat}
              names={names}
              scores={scores}
            />
          </PopoverBody>
        </PopoverContent>
      </Popover>
    );
  }

  return (
    <TableContainer
      border="1px solid black"
      position="absolute"
      right={{ md: "16px", lg: "50px" }}
      top={{ base: "8px", md: "8px", lg: "16px" }}
      bg="white"
      // Cutthroat's wider (3-4 column) table reaches further left than the
      // old fixed Us/Them pair ever did, into the same screen region as the
      // top player's dealt cards - which sit inside a .player element with
      // an explicit z-index:2 (Deck.css). Without a z-index here the
      // scoreboard has none (stacking order falls back to DOM position),
      // so those cards painted over its leftmost column. Matches the
      // z-index already on the mobile "Score" trigger button below.
      zIndex={3}
    >
      <ScoreTable
        teamAScore={teamAScore}
        teamBScore={teamBScore}
        size={size}
        isCutthroat={isCutthroat}
        names={names}
        scores={scores}
      />
    </TableContainer>
  );
};
export default ScoreBoard;
